import React from 'react';
import Button from '../../components/Button/Button';

import eye from '../../brand/generated/popover/eye.svg';
import bucket from '../../brand/generated/popover/delete.svg';
import edit from '../../brand/generated/popover/edit.svg';
import set from '../../brand/generated/popover/set.svg';

export const ASSIGN_TITLE = 'ÐÐ°Ð·Ð½Ð°ÑÐ¸ÑÑ Ð¾ÑÐ²ÐµÑÑÑÐ²ÐµÐ½Ð½Ð¾Ð³Ð¾';

const POPOVER = [
  { title: 'ÐÑÐ¾ÑÐ¼Ð¾ÑÑÐµÑÑ Ð»Ð¸Ð´', icon: eye },
  { title: 'Ð ÐµÐ´Ð°ÐºÑÐ¸ÑÐ¾Ð²Ð°ÑÑ Ð»Ð¸Ð´', icon: edit },
  { title: ASSIGN_TITLE, icon: set },
  { title: 'Ð£Ð´Ð°Ð»Ð¸ÑÑ Ð»Ð¸Ð´', icon: bucket },
];

/** ÐÐµÐ½Ñ ÑÑÑÐ¾ÐºÐ¸ ÑÐ¿Ð¸ÑÐºÐ° Ð»Ð¸Ð´Ð¾Ð². Ð ÑÐ´Ð¾Ð²Ð¾Ð¹ Ð¼ÐµÐ½ÐµÐ´Ð¶ÐµÑ Ð»Ð¸Ð´Ñ Ð½Ðµ ÑÐ°Ð·Ð´Ð°ÑÑ â Â«ÐÐ°Ð·Ð½Ð°ÑÐ¸ÑÑÂ» ÐµÐ¼Ñ Ð½Ðµ Ð¿Ð¾ÐºÐ°Ð·ÑÐ²Ð°ÐµÐ¼. */
export const leadPopover = (isManager) => (isManager ? POPOVER.filter((item) => item.title !== ASSIGN_TITLE) : POPOVER);

// Ð¤Ð¾Ð½ Ð¸ Ð¾ÑÑÑÑÐ¿Ñ Ð·Ð°Ð´Ð°ÑÐ¼ ÑÑÑ: `.table td button` ÑÐ±ÑÐ°ÑÑÐ²Ð°ÐµÑ Ð¸Ñ Ñ Ð»ÑÐ±Ð¾Ð¹ ÐºÐ½Ð¾Ð¿ÐºÐ¸ Ð² ÑÑÐµÐ¹ÐºÐµ,
// Ð¸ Ð±ÐµÐ»ÑÐ¹ ÑÐµÐºÑÑ Â«ÐÑÐ¸Ð½ÑÑÑÂ» Ð¾ÑÑÐ°Ð²Ð°Ð»ÑÑ Ð½Ð° ÑÐ¾Ð·Ð¾Ð²Ð¾Ð¹ ÑÑÑÐ¾ÐºÐµ Ð±ÐµÐ· Ð¿Ð¾Ð´Ð»Ð¾Ð¶ÐºÐ¸.
const acceptButtonStyle = {
  backgroundColor: 'var(--brand-primary)',
  padding: '6px 14px',
  fontSize: 12,
  lineHeight: '16px',
  minHeight: 0,
  height: 'auto',
};

/**
 * ÐÐ¸Ð´ Ð±ÐµÐ· Ð¾ÑÐ²ÐµÑÑÑÐ²ÐµÐ½Ð½Ð¾Ð³Ð¾: Ð² ÐºÐ¾Ð»Ð¾Ð½ÐºÐµ Â«ÐÐµÐ½ÐµÐ´Ð¶ÐµÑÂ» Ð²Ð¼ÐµÑÑÐ¾ Ð¿ÑÑÑÐ¾ÑÑ â ÐºÐ½Ð¾Ð¿ÐºÐ° Ð¿ÑÐ¸ÑÐ¼Ð°.
 * onAccept ÑÐ¸ÑÐ°ÐµÑÑÑ Ð² Ð¼Ð¾Ð¼ÐµÐ½Ñ ÐºÐ»Ð¸ÐºÐ° (ÑÐµÑÐµÐ· ÑÑÐ½ÐºÑÐ¸Ñ), ÑÑÐ¾Ð±Ñ Ð½Ðµ Ð¿ÐµÑÐµÑÐ¾Ð·Ð´Ð°Ð²Ð°ÑÑ ÐºÐ¾Ð»Ð¾Ð½ÐºÐ¸
 * Ð½Ð° ÐºÐ°Ð¶Ð´ÑÐ¹ ÑÐµÐ½Ð´ÐµÑ ÑÐ¿Ð¸ÑÐºÐ°.
 */
export const withAcceptCell = (columns, getOnAccept) =>
  columns.map((column) =>
    column.Header === 'ÐÐµÐ½ÐµÐ´Ð¶ÐµÑ'
      ? {
          ...column,
          Cell: ({ row }) =>
            row.original.manager?.fullName || (
              <Button text="ÐÑÐ¸Ð½ÑÑÑ" fill style={acceptButtonStyle} onClick={() => getOnAccept()(row.original)} />
            ),
        }
      : column
  );
